import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ContentSection from './components/ContentSection';
import Footer from './components/Footer';

export default function Home() {
  const organizationSchema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Hipobuy Spreadsheet Hub',
    url: 'https://hipobuyspread.lol/',
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
    description: 'The ultimate Hipobuy Spreadsheet resource hub for organized product discovery, category guides, comparison resources, and expert buying insights.',
    foundingDate: '2026',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['English'],
    },
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <ContentSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: organizationSchema }}
      />
    </div>
  );
}